import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'volunteer-card',
    styleUrls: ['./volunteer-card.scss'],
    templateUrl: './volunteer-card.html',
    standalone: true,
    imports: [CommonModule, DatePipe]
})
export class VolunteerCardComponent implements OnInit {
  appURL: string = environment.appURL;
  today: any;

  constructor() {}

  ngOnInit() {
    this.today = Math.floor(Date.now());
  }
}
